/* Page karkotuspussi uniquement (layout karkotus).
   Remplace le JavaScript GemPages / Kaching / Loox / Dawn de la référence Bronoir :
   galerie, carrousels, accordéons, offres, ajout au panier, tiroir panier, menu, recherche, avis. */
(function () {
  'use strict';
  var CFG = window.KarkotusConfig || {};
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var SECTION = CFG.section || 'karkotus-cart-drawer';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };

  /* ---------- glisser (souris / doigt) ---------- */
  function onSwipe(el, cb) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cb(dx < 0 ? 1 : -1);
      x0 = null;
    });
    var mx = null;
    el.addEventListener('mousedown', function (e) { mx = e.clientX; });
    el.addEventListener('mouseup', function (e) { if (mx !== null && Math.abs(e.clientX - mx) > 40) cb(e.clientX < mx ? 1 : -1); mx = null; });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- galerie ---------- */
  function initGallery(g) {
    var track = $('[data-kp-gal-track]', g);
    var thumbs = $$('.kp-gallery__thumb', g);
    var tTrack = $('[data-kp-gal-thumbs]', g), tView = $('[data-kp-gal-viewport]', g);
    var prev = $('[data-kp-gal-prev]', g), next = $('[data-kp-gal-next]', g);
    var n = track ? track.children.length : 0, i = 0;
    var loop = g.classList.contains('kp-gallery--d');
    function go(k) {
      if (!n) return;
      if (loop) k = (k + n) % n; else k = Math.max(0, Math.min(n - 1, k));
      i = k;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      if (tTrack && tView && thumbs[i]) {
        var tw = thumbs[i].offsetWidth + 8, vis = Math.floor((tView.offsetWidth + 8) / tw);
        var maxOff = Math.max(0, tTrack.scrollWidth - tView.offsetWidth);
        var off = Math.min(maxOff, Math.max(0, (i - vis + 1) * tw));
        var cur = -parseFloat((tTrack.style.transform.match(/-?[\d.]+/) || [0])[0]);
        if (thumbs[i].offsetLeft < cur) off = thumbs[i].offsetLeft;
        else if (thumbs[i].offsetLeft + thumbs[i].offsetWidth <= cur + tView.offsetWidth) off = cur;
        tTrack.style.transform = 'translateX(' + (-Math.min(off, maxOff)) + 'px)';
      }
      if (!loop) {
        if (prev) prev.toggleAttribute('hidden-state', i === 0);
        if (next) next.toggleAttribute('hidden-state', i === n - 1);
      }
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    onSwipe($('.kp-gallery__main', g), function (d) { go(i + d); });
    go(0);
  }

  /* ---------- carrousels GemPages ---------- */
  var CAROUSELS = {
    'g-_S0LSfwr': { dots: true, dotSize: [12, 10], dotGap: [16, 14], loop: [false, true] },
    'gaBlnHzUIe': { loop: [true, true], center: [true, false], perView: 1 },
    'gGEIZirsPh': { loop: [true, true] }
  };
  function initCarousel(root) {
    var id = root.getAttribute('data-kp-carousel');
    var cfg = CAROUSELS[id] || {};
    var view = $('.kp-viewport', root), wrap = $('.gem-slider-wrapper', root);
    if (!view || !wrap) return;
    var items = $$('.gem-slider-item', wrap).filter(function (x) { return x.parentElement === wrap; });
    var prev = $$('.gem-slider-previous', root).filter(function (b) { return b.closest('[data-kp-carousel]') === root; })[0];
    var next = $$('.gem-slider-next', root).filter(function (b) { return b.closest('[data-kp-carousel]') === root; })[0];
    var dotsBox = $$('.gp-carousel-dot-container', root).filter(function (b) { return b.closest('[data-kp-carousel]') === root; })[0];
    var i = 0, dots = [];
    function center() { return !!(cfg.center && cfg.center[isMobile() ? 1 : 0]); }
    if (cfg.center && items.length > 2) { // clones pour l'aperçu des cartes voisines (mode centré de la référence)
      var c0 = items[items.length - 1].cloneNode(true), c1 = items[0].cloneNode(true), c2 = items[1].cloneNode(true);
      [c0, c1, c2].forEach(function (c) { c.setAttribute('aria-hidden', 'true'); c.classList.add('kp-clone'); });
      wrap.insertBefore(c0, items[0]); wrap.appendChild(c1); wrap.appendChild(c2);
    }
    function maxIndex() {
      if (center()) return items.length - 1;
      var last = items[items.length - 1];
      if (!last) return 0;
      var end = last.offsetLeft + last.offsetWidth;
      for (var k = 0; k < items.length; k++) if (end - items[k].offsetLeft <= view.clientWidth + 2) return k;
      return items.length - 1;
    }
    function loop() { return (cfg.loop || [false, false])[isMobile() ? 1 : 0]; }
    function go(k) {
      var m = maxIndex();
      if (k > m) k = loop() ? 0 : m;
      if (k < 0) k = loop() ? m : 0;
      i = k;
      var x;
      if (center()) {
        var w = items[0].offsetWidth, gap = (items[1] ? items[1].offsetLeft - items[0].offsetLeft - w : 0), per = cfg.perView || 1;
        x = -items[i].offsetLeft + (view.clientWidth - (per * w + (per - 1) * gap)) / 2;
      } else {
        var first = wrap.querySelector('.gem-slider-item:not(.kp-clone)');
        x = -(items[i] ? items[i].offsetLeft - first.offsetLeft : 0) - (first.offsetLeft - wrap.firstElementChild.offsetLeft);
      }
      wrap.style.transform = 'translate3d(' + x + 'px,0,0)';
      dots.forEach(function (d, j) {
        var on = j === i;
        d.classList.toggle('gp-carousel-dot--active', on);
        d.style.backgroundColor = on ? 'var(--g-c-line-3, #121212)' : 'var(--g-c-bg-1, #e2e2e2)';
      });
      if (!loop()) {
        if (prev) prev.classList.toggle('kp-disabled', i === 0);
        if (next) next.classList.toggle('kp-disabled', i >= m);
      }
    }
    if (cfg.dots && dotsBox) {
      dotsBox.innerHTML = '';
      items.forEach(function (it, j) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'gp-carousel-dot'; b.setAttribute('aria-label', 'Siirry diaan ' + (j + 1));
        var size = (cfg.dotSize || [12, 10])[isMobile() ? 1 : 0];
        b.style.cssText = 'aspect-ratio:1/1;width:' + size + 'px;border-radius:9999px;box-shadow:0 4px 6px -1px rgba(0,0,0,.1);';
        b.addEventListener('click', function () { go(j); });
        dotsBox.appendChild(b); dots.push(b);
      });
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    onSwipe(view, function (d) { go(i + d); });
    window.addEventListener('resize', function () { go(i); });
    go(0);
  }

  /* ---------- accordéons ---------- */
  function initAccordion(acc) {
    var heads = $$('.gp-accordion-item_header', acc);
    heads.forEach(function (h) {
      var idx = h.getAttribute('data-index');
      var item = h.parentElement;
      var body = $('.gp-accordion-item_body[data-index="' + idx + '"]', item) || h.nextElementSibling;
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.removeAttribute('aria-hidden');
      h.setAttribute('aria-expanded', 'false');
      function toggle() {
        var open = !item.classList.contains('kp-open');
        heads.forEach(function (o) { // mode « un seul ouvert »
          var it = o.parentElement, b = $('.gp-accordion-item_body', it);
          it.classList.remove('kp-open'); o.setAttribute('aria-expanded', 'false');
          if (b) b.style.maxHeight = '0px';
        });
        if (open) {
          item.classList.add('kp-open'); h.setAttribute('aria-expanded', 'true');
          if (body) body.style.maxHeight = body.scrollHeight + 'px';
        }
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------- offres ---------- */
  function selectedQty() {
    var bar = $('.kp-deals .kaching-bundles__bar--selected');
    return bar ? parseInt(bar.getAttribute('data-kp-qty'), 10) || 1 : 1;
  }
  function initDeals(box) {
    $$('.kaching-bundles__bar', box).forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        e.preventDefault();
        $$('.kaching-bundles__bar', box).forEach(function (b) {
          var on = b === bar;
          b.classList.toggle('kaching-bundles__bar--selected', on);
          var r = $('input[type="radio"]', b); if (r) r.checked = on;
        });
      });
    });
  }

  /* ---------- panier ---------- */
  function drawer() { return $('cart-drawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
  function setBubble(count) {
    var a = $('#cart-icon-bubble'); if (!a) return;
    var b = $('.cart-count-bubble', a);
    if (!count) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
    b.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' tuotetta</span>';
  }
  var renderSeq = 0;
  function renderDrawer(open) {
    var seq = ++renderSeq;
    // garder la requête de la page (preview_key de l'aperçu Shopify) ; repli sur l'accueil si la réponse n'est pas du JSON
    var q = window.location.search;
    var getSections = function (url) { return fetch(url, { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.json(); }); };
    return getSections(window.location.pathname + q + (q ? '&' : '?') + 'sections=' + SECTION)
      .catch(function () { return getSections(ROOT + '?sections=' + SECTION); })
      .then(function (json) {
        if (seq !== renderSeq) return;
        var html = json[SECTION]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('cart-drawer', doc), cur = drawer();
        if (fresh && cur) {
          var wasActive = cur.classList.contains('active');
          cur.className = fresh.className + (wasActive || open ? ' animate active' : '');
          cur.innerHTML = fresh.innerHTML;
          bindDrawer();
        }
        return fetch(ROOT + 'cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setBubble(c.item_count); }).catch(function () {});
      });
  }
  function changeLine(line, qty) {
    var d = drawer(); if (d) d.querySelector('.drawer__inner').classList.add('is-loading');
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); })
      .then(function () { return renderDrawer(true); })
      .catch(function () { return renderDrawer(true); })
      .catch(function () {})
      .then(function () { var dd = drawer(); if (dd) { var inner = dd.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-loading'); } });
  }
  function bindDrawer() {
    var d = drawer(); if (!d) return;
    $$('[data-kp-close]', d).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    $$('quantity-input[data-kp-line]', d).forEach(function (q) {
      var line = parseInt(q.getAttribute('data-kp-line'), 10), off = parseInt(q.getAttribute('data-kp-offset'), 10) || 0;
      var input = $('input', q);
      $$('[data-kp-step]', q).forEach(function (b) {
        b.addEventListener('click', function () { changeLine(line, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-kp-step'), 10) + off); });
      });
      input.addEventListener('change', function () { changeLine(line, (parseInt(input.value, 10) || 0) + off); });
    });
    $$('[data-kp-remove]', d).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(parseInt(b.getAttribute('data-kp-remove'), 10), 0); });
    });
    // upsell du panier (« Usein ostetaan myös ») : ajoute 1 produit puis recharge le panier
    $$('[data-kp-upsell]', d).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('loading')) return;
        b.classList.add('loading');
        var err = b.parentNode.querySelector('.cart-drawer-upsell__error');
        fetch(ROOT + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-kp-upsell'), 10), quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return renderDrawer(true); })
          .catch(function (e) {
            b.classList.remove('loading');
            if (err) { err.textContent = (e && e.description) || 'Jokin meni vikaan. Yritä uudelleen.'; err.classList.add('is-visible'); }
          });
      });
    });
  }
  function addToCart(qty, btn) {
    var id = CFG.variantId; if (!id || qty < 1) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { openDrawer(); return renderDrawer(true).catch(function () {}); })
      .catch(function (e) { window.alert((e && e.description) || 'Jokin meni vikaan. Yritä uudelleen.'); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------- barre fixe : quantité ---------- */
  function initQtyBox(box) {
    var input = $('input', box), btns = $$('button', box);
    if (!input || btns.length < 2) return;
    btns[0].addEventListener('click', function (e) { e.preventDefault(); input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    btns[btns.length - 1].addEventListener('click', function (e) { e.preventDefault(); input.value = (parseInt(input.value, 10) || 1) + 1; });
  }

  /* ---------- barre fixe : sur mobile, visible une fois le premier bouton d'ajout dépassé (réglage de la référence) ---------- */
  function initSticky(st) {
    var first = $('main [data-kp-atc]:not([data-kp-atc="sticky"])');
    if (!first) return;
    function check() {
      var r = first.getBoundingClientRect();
      st.style.setProperty('--d-mobile', r.bottom < 0 ? 'block' : 'none');
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- menu mobile et recherche (Dawn) ---------- */
  function initHeader() {
    var md = $('#Details-menu-drawer-container');
    if (md) {
      var sum = $('summary', md);
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (md.hasAttribute('open')) {
          md.classList.remove('menu-opening'); sum.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
          setTimeout(function () { md.removeAttribute('open'); }, 300);
        } else {
          md.setAttribute('open', ''); sum.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () { md.classList.add('menu-opening'); });
          document.body.classList.add('overflow-hidden-tablet');
        }
      });
    }
    var sm = $('.header__search details');
    if (sm) {
      var close = $('.search-modal__close-button', sm), overlay = $('.modal-overlay', sm);
      $('summary', sm).addEventListener('click', function () {
        setTimeout(function () { var inp = $('input[type="search"]', sm); if (sm.hasAttribute('open') && inp) inp.focus(); }, 50);
      });
      [close, overlay].forEach(function (b) { if (b) b.addEventListener('click', function () { sm.removeAttribute('open'); }); });
    }
    var cartIcon = $('#cart-icon-bubble');
    if (cartIcon) cartIcon.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); renderDrawer(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); if (sm) sm.removeAttribute('open'); } });
  }

  /* ---------- avis (widget) ---------- */
  function initReviews(w) {
    var grid = $('[data-kp-loox-grid]', w); if (!grid) return;
    var all = $$('[data-kp-review]', grid), shown = 14, filter = 0, order = all.slice();
    var more = $('[data-kp-loox-more]', w);
    function layout() {
      var width = grid.clientWidth || w.clientWidth;
      var cols = Math.max(2, Math.min(6, Math.floor(width / 220)));
      var colW = width / cols, heights = [];
      for (var c = 0; c < cols; c++) heights.push(0);
      grid.style.position = 'relative';
      order.forEach(function (el) {
        if (el.hidden) { el.style.position = ''; return; }
        var k = heights.indexOf(Math.min.apply(null, heights));
        el.style.position = 'absolute'; el.style.width = colW + 'px';
        el.style.left = (k * colW) + 'px'; el.style.top = heights[k] + 'px';
        heights[k] += el.offsetHeight;
      });
      grid.style.height = Math.max.apply(null, heights) + 'px';
    }
    function apply() {
      var list = order.filter(function (el) { return !filter || +el.getAttribute('data-stars') === filter; });
      order.forEach(function (el) { el.hidden = true; });
      list.slice(0, shown).forEach(function (el) { el.hidden = false; });
      if (more) more.style.display = list.length > shown ? '' : 'none';
      order.forEach(function (el) { grid.appendChild(el); });
      layout();
    }
    if (more) more.addEventListener('click', function (e) { e.preventDefault(); shown += 14; apply(); });
    // distribution des notes (clic sur « 47 arvostelua »)
    var sumBtn = $('[data-panel="dist"]', w), dist = $('.reviews-dist', w);
    if (sumBtn && dist) sumBtn.addEventListener('click', function (e) {
      e.preventDefault(); var on = !dist.classList.contains('kp-show');
      dist.classList.toggle('kp-show', on); dist.classList.toggle('shown', on); sumBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      $$('.chevron-open', sumBtn).forEach(function (s) { s.classList.toggle('chevron-hide', on); });
      $$('.chevron-closed', sumBtn).forEach(function (s) { s.classList.toggle('chevron-hide', !on); });
    });
    $$('.rating-dist-row:not(.no-reviews)', w).forEach(function (row) {
      row.addEventListener('click', function () {
        var r = +row.getAttribute('data-rating');
        filter = filter === r ? 0 : r; shown = 14;
        $$('.rating-dist-row', w).forEach(function (x) { x.classList.toggle('kp-active', filter && +x.getAttribute('data-rating') === filter); x.setAttribute('aria-pressed', filter && +x.getAttribute('data-rating') === filter ? 'true' : 'false'); });
        apply();
      });
    });
    // tri
    var menuBtn = $('#menu-btn', w), menu = $('.menu .loox-dropdown, .menu [role="menu"], .menu ul', w);
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function (e) { e.preventDefault(); var on = !menu.classList.contains('shown'); menu.classList.toggle('kp-show', on); menu.classList.toggle('shown', on); });
      $$('button[data-sort], [role="menuitemradio"], .menu li button', menu).forEach(function (b, j) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var key = (b.getAttribute('aria-label') || '').toLowerCase();
          order = all.slice();
          if (key.indexOf('parhaat') > -1) order.sort(function (a, c) { return c.getAttribute('data-stars') - a.getAttribute('data-stars'); });
          if (key.indexOf('huonoimmat') > -1) order.sort(function (a, c) { return a.getAttribute('data-stars') - c.getAttribute('data-stars'); });
          $$('button', menu).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          menu.classList.remove('kp-show', 'shown'); $$('li span', menu).forEach(function (sp) { sp.classList.remove('chosen-option'); }); var sp = b.querySelector('span') || (b.parentElement && b.parentElement.querySelector('span')); if (sp) sp.classList.add('chosen-option'); shown = 14; apply();
        });
      });
    }
    window.addEventListener('resize', layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout);
    apply();
  }

  /* ---------- démarrage ---------- */
  function init() {
    $$('[data-kp-gallery]').forEach(initGallery);
    $$('[data-kp-carousel]').forEach(initCarousel);
    $$('[data-kp-accordion]').forEach(initAccordion);
    $$('[data-kp-deals]').forEach(initDeals);
    $$('[data-kp-qty-box]').forEach(initQtyBox);
    $$('[data-kp-atc]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var qty = selectedQty();
        if (b.getAttribute('data-kp-atc') === 'sticky') {
          var box = $('[data-kp-qty-box] input'); qty = qty * Math.max(1, parseInt(box && box.value, 10) || 1);
        }
        addToCart(qty, b);
      });
    });
    $$('a[href="#looxReviews"]').forEach(function (a) {
      a.addEventListener('click', function (e) { var t = $('#looxReviews'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } });
    });
    initHeader();
    bindDrawer();
    $$('[data-kp-sticky]').forEach(initSticky);
    var lr = $('#looxReviews'); if (lr) initReviews(lr);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
